import Swal from "sweetalert2";

import inMemoryJWT from "../../auth/inMemoryJwt";
import { urlServer } from "../../config/GlobalConstant";
import {
  CREATE_PRODUCT,
  CREATE_PRODUCTS_PRESENTATIONS,
  DELETE_PRODUCT,
  DELETE_PRODUCTS_PRESENTATIONS,
  EDIT_PRODUCT,
  EDIT_PRODUCTS_PRESENTATIONS,
  ERROR_PRODUCT,
  GET_PRODUCT,
  IS_LOADING_LANDINGS,
  IS_LOADING_PRODUCT,
  IS_LOADING_PRODUCTS,
  LIST_OF_PRODUCTS,
  LIST_OF_PRODUCTS_PRESENTATIONS,
  IS_LOADING_REPORT_BY_TYPE,
  REPORT_BY_TYPE,
  IS_LOADING_UTILITY_REPORT, 
  UTILITY_REPORT
} from "./types";
const toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 2000,
});
export const getProduct = (productId) => async (dispatch) => {
  dispatch({
    //Esto se lo envía a combineReducer, el que está en el index
    type: IS_LOADING_PRODUCT,
  });
  await fetch(`${urlServer}products/get-one-by-id`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      Authorization: `bearer ${inMemoryJWT.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
      "Content-Type": "application/json",
    }, // body data type must match "Content-Type" header
    body: JSON.stringify({ productId: productId }),
  })
    .then((response) => response.json())
    .then((respJson) => {
      console.log();

      dispatch({
        type: GET_PRODUCT,
        payload: respJson.data
      });

    });
};
export const createProduct = (createProduct, history) => async (dispatch) => {
  dispatch({
    //Esto se lo envía a combineReducer, el que está en el index
    type: IS_LOADING_PRODUCTS,
  });
  await fetch(`${urlServer}products/create`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      Authorization: `bearer ${inMemoryJWT.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    }, // body data type must match "Content-Type" header
    body: createProduct,
  })
    .then((response) => response.json())
    .then((respJson) => {
      console.log();
      if (respJson.success) {
        //  formRef.current.resetForm();
        toast.fire({
          text:"Producto creado"
        })
        dispatch({
          //Esto se lo envía a combineReducer, el que está en el index
          type: CREATE_PRODUCT,
          payload: respJson.data,
        });
        history.push('/Admin/Inventory/Products/')
      } else {
        if (respJson.error.code) {
          toast.fire({
            title: "Ya existe en producto con el mismo código o nombre",
            icon: "error",
          });
        } else {
          toast.fire({
            title: "No se pudo crear el producto",
            icon: "error",
          });
        }

        dispatch({
          type: ERROR_PRODUCT,
        });
      }
    });
};

export const SeeProductsByWinery = (id) => async (dispatch) => {
  dispatch({
    //Esto se lo envía a combineReducer, el que está en el index
    type: IS_LOADING_PRODUCTS,
  });
  await fetch(`${urlServer}products/get-products-by-any-id`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJWT.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    }, // body data type must match "Content-Type" header
    body: JSON.stringify({ locationID: id }),
  })
    .then((response) => response.json())
    .then((respJson) => {
      console.log();
      dispatch({
        //Esto se lo envía a combineReducer, el que está en el index
        type: LIST_OF_PRODUCTS,
        payload: respJson.data,
      });
    })
    .catch((error) => {
      console.log();
    });
};
export const SeeProductsHistory = () => async (dispatch) => {
  dispatch({
    //Esto se lo envía a combineReducer, el que está en el index
    type: IS_LOADING_PRODUCTS,
  });
  await fetch(`${urlServer}historyofeliminatedproducts/get-all`, {
    method: "GET", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJWT.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    }, // body data type must match "Content-Type" header
  })
    .then((response) => response.json())
    .then((respJson) => {
      console.log();
      dispatch({
        //Esto se lo envía a combineReducer, el que está en el index
        type: LIST_OF_PRODUCTS,
        payload: respJson.data,
      });
    })
    .catch((error) => {
      console.log();
    });
};
export const SeeProducts = () => async (dispatch) => {
  dispatch({
    //Esto se lo envía a combineReducer, el que está en el index
    type: IS_LOADING_PRODUCTS,
  });
  await fetch(`${urlServer}products/get-all`, {
    method: "GET", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJWT.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    }, // body data type must match "Content-Type" header
  })
    .then((response) => response.json())
    .then((respJson) => {
      console.log();
      dispatch({
        //Esto se lo envía a combineReducer, el que está en el index
        type: LIST_OF_PRODUCTS,
        payload: respJson.data,
      });
    })
    .catch((error) => {
      console.log();
    });
};

///presentaciones
export const createProductsPresentations = (name, clear) => async (dispatch) => {

  await fetch(`${urlServer}adminproductpresentations/create`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJWT.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    }, // body data type must match "Content-Type" header,
    body: JSON.stringify({
      name
    })
  })
    .then((response) => response.json())
    .then((respJson) => {
      console.log();
      if (respJson.success) {
        dispatch({
          //Esto se lo envía a combineReducer, el que está en el index
          type: CREATE_PRODUCTS_PRESENTATIONS,
          payload: respJson.data,
        });
        clear()
      } else {
        toast.fire({
          icon: "error",
          text: respJson.error.code ==="ERR032" ? "Ya existe una presentación con el mismo nombre" : "No se pudo crear la presentación"
        })
      }
    })
    .catch((error) => {
      console.log();
    });
}
export const editProductsPresentations = (name, presentationID, clear) => async (dispatch) => {

  await fetch(`${urlServer}adminproductpresentations/update`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJWT.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    }, // body data type must match "Content-Type" header,
    body: JSON.stringify({
      name,
      presentationID
    })
  })
    .then((response) => response.json())
    .then((respJson) => {
      console.log();
      if (respJson.success) {
        dispatch({
          //Esto se lo envía a combineReducer, el que está en el index
          type: EDIT_PRODUCTS_PRESENTATIONS,
          payload: respJson.data,
        });
        clear()
      } else {
        toast.fire({
          icon: "error",
          text: respJson.error.code ==="ERR032" ? "Ya existe una presentación con el mismo nombre" : "No se pudo editar la presentación"
        })
      }
    })
    .catch((error) => {
      console.log();
    });
}

export const deleteProductsPresentations = (presentationID, clear) => async (dispatch) => {

  await fetch(`${urlServer}adminproductpresentations/update`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJWT.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    }, // body data type must match "Content-Type" header,
    body: JSON.stringify({
      presentationID
    })
  })
    .then((response) => response.json())
    .then((respJson) => {
      console.log();
      if (respJson.success) {
        dispatch({
          //Esto se lo envía a combineReducer, el que está en el index
          type: DELETE_PRODUCTS_PRESENTATIONS,
          payload: respJson.data,
        });
        clear()
      } else {
        toast.fire({
          icon: "error",
          text: "La presentación no se pudo borrar"
        })
      }
    })
    .catch((error) => {
      console.log();
    });
}

export const SeeProductsPresentations = () => async (dispatch) => {
  dispatch({
    //Esto se lo envía a combineReducer, el que está en el index
    type: IS_LOADING_PRODUCTS,
  });
  await fetch(`${urlServer}adminproductpresentations/get-all`, {
    method: "GET", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJWT.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    }, // body data type must match "Content-Type" header
  })
    .then((response) => response.json())
    .then((respJson) => {
      console.log();
      dispatch({
        //Esto se lo envía a combineReducer, el que está en el index
        type: LIST_OF_PRODUCTS_PRESENTATIONS,
        payload: respJson.data,
      });
    })
    .catch((error) => {
      console.log();
    });
};
export const SeeProductsByCode = (code) => async (dispatch) => {
  dispatch({
    //Esto se lo envía a combineReducer, el que está en el index
    type: IS_LOADING_PRODUCTS,
  });
  await fetch(`${urlServer}products/get-filters`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJWT.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    }, // body data type must match "Content-Type" header
    body: JSON.stringify({ code })
  })
    .then((response) => response.json())
    .then((respJson) => {
      console.log();
      if (respJson.success) {
        dispatch({
          //Esto se lo envía a combineReducer, el que está en el index
          type: LIST_OF_PRODUCTS,
          payload: respJson.data,
        });
      } else if(code != "" ) {
        dispatch({
          //Esto se lo envía a combineReducer, el que está en el index
          type: LIST_OF_PRODUCTS,
          payload: []
        });
      }else{
        dispatch(SeeProducts())
      }
    })
    .catch((error) => {
      console.log();
    });
};
export const SeeProductsByName = (textString ) => async (dispatch) => {
  dispatch({
    //Esto se lo envía a combineReducer, el que está en el index
    type: IS_LOADING_PRODUCTS,
  });
  await fetch(`${urlServer}products/get-filters`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJWT.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    }, // body data type must match "Content-Type" header
    body: JSON.stringify({ textString })
  })
    .then((response) => response.json())
    .then((respJson) => {
      console.log();
      if (respJson.success) {
        dispatch({
          //Esto se lo envía a combineReducer, el que está en el index
          type: LIST_OF_PRODUCTS,
          payload: respJson.data,
        });
      } else if(textString  != "" ) {
        dispatch({
          //Esto se lo envía a combineReducer, el que está en el index
          type: LIST_OF_PRODUCTS,
          payload: []
        });
      }else{
        dispatch(SeeProducts())
      }
    })
    .catch((error) => {
      console.log();
    });
};

export const SeeProductsByPresentation = (presentationId ) => async (dispatch) => {
  dispatch({
    //Esto se lo envía a combineReducer, el que está en el index
    type: IS_LOADING_PRODUCTS,
  });
  await fetch(`${urlServer}products/get-filters`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJWT.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    }, // body data type must match "Content-Type" header
    body: JSON.stringify({ presentationId })
  })
    .then((response) => response.json())
    .then((respJson) => {
      console.log();
      if (respJson.success) {
        dispatch({
          //Esto se lo envía a combineReducer, el que está en el index
          type: LIST_OF_PRODUCTS,
          payload: respJson.data,
        });
      } else if(!presentationId) {
        dispatch({
          //Esto se lo envía a combineReducer, el que está en el index
          type: LIST_OF_PRODUCTS,
          payload: []
        });
      }else{
        dispatch(SeeProducts())
      }
    })
    .catch((error) => {
      console.log();
    });
};
export const deleteProduct = (id, removalReason,close) => async (dispatch) => {
  dispatch({
    //Esto se lo envía a combineReducer, el que está en el index 61b234836a1bb35e7dd4bd8d
    type: IS_LOADING_PRODUCTS,
  });
  await fetch(`${urlServer}products/delete`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      Authorization: `bearer ${inMemoryJWT.getToken()}`,
      "Content-Type": "application/json",
      // 'Content-Type': 'application/x-www-form-urlencoded',
    }, // body data type must match "Content-Type" header
    body: JSON.stringify({ productId: id, removalReason }),
  })
    .then((response) => response.json())
    .then((respJson) => {
      close()
      dispatch({
        //Esto se lo envía a combineReducer, el que está en el index
        type: DELETE_PRODUCT,
        payload: id,
      });
    });
};
export const updateProduct = (updateProduct, id,history) => async (dispatch) => {
    updateProduct.append("productId", id);
    dispatch({
      //Esto se lo envía a combineReducer, el que está en el index
      type: IS_LOADING_PRODUCTS,
    });
    await fetch(`${urlServer}products/update`, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      withCredentials: true,
      credentials: "include",
      headers: {
        Authorization: `bearer ${inMemoryJWT.getToken()}`,
      }, // body data type must match "Content-Type" header
      body: updateProduct,
    })
      .then((response) => response.json())
      .then((respJson) => {
        if (respJson.success) {
          //formRef.current.resetForm();
          toast.fire({
            text:"Producto actualizado"
          })
          dispatch({
            //Esto se lo envía a combineReducer, el que está en el index
            type: EDIT_PRODUCT,
            payload: respJson.data,
          });
          history.push('/Admin/Inventory/products/')
        } else {
          if (respJson.error.code) {
            toast.fire({
              title: "Ya existe en producto con el mismo código o nombre",
              icon: "error",
            });
          } else {
            toast.fire({
              title: "No se pudo editar el producto",
              icon: "error",
            });
          }
        }
      });
  };
export const getProductsById = (id) => async (dispatch) => {
  //This method required id from winery/subwinery or Warehouse
  dispatch({
    //Esto se lo envía a combineReducer, el que está en el index
    type: IS_LOADING_PRODUCTS,
  });
  await fetch(`${urlServer}mainproductbatches/get-products-by-location`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJWT.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    }, // body data type must match "Content-Type" header
    body: JSON.stringify({ locationId: id, limit: 1000, skip: 0 }),
  })
    .then((response) => response.json())
    .then((respJson) => {
      dispatch({
        //Esto se lo envía a combineReducer, el que está en el index
        type: LIST_OF_PRODUCTS,
        payload: respJson.data,
      });
    })
    .catch((error) => {
      console.log();
    });
};

export const getReportByType = (reportType, initialDate, finalDate) => async (dispatch) => {
  //This method required id from winery/subwinery or Warehouse
  dispatch({
    //Esto se lo envía a combineReducer, el que está en el index
    type: IS_LOADING_REPORT_BY_TYPE,
  });
  await fetch(`${urlServer}productsuborders/get-report-by-type`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJWT.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    }, // body data type must match "Content-Type" header
    body: JSON.stringify({ reportType, initialDate, finalDate }),
  })
    .then((response) => response.json())
    .then((respJson) => {
      dispatch({
        //Esto se lo envía a combineReducer, el que está en el index
        type: REPORT_BY_TYPE,
        payload: respJson.data,
      });
    })
    .catch((error) => {
      console.log();
    });
};

export const getUtilityReport = (initialDate, finalDate) => async (dispatch) => {
  //This method required id from winery/subwinery or Warehouse
  dispatch({
    //Esto se lo envía a combineReducer, el que está en el index
    type: IS_LOADING_UTILITY_REPORT,
  });
  await fetch(`${urlServer}productsuborders/get-utility`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJWT.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    }, // body data type must match "Content-Type" header
    body: JSON.stringify({ initialDate, finalDate }),
  })
    .then((response) => response.json())
    .then((respJson) => {
      dispatch({
        //Esto se lo envía a combineReducer, el que está en el index
        type: UTILITY_REPORT,
        payload: respJson.data,
      });
    })
    .catch((error) => {
      console.log();
    });
};
